var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLatu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 317 246",
    width: 317,
    height: 246,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo-LATU-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #009ddc } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Artboards_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m118.5 46.3l62.4 5.5c1.1 0.1 2 0.6 2.4 1.5 0.4 1 0.2 2-0.5 2.8 0 0-33.3 47.1-33.3 47.1q-0.2 0.4-0.7 0.6c-0.7 0.4-1.7-0.1-2.2-1.1-0.1-0.3-0.2-0.7-0.2-1l4.4-20.2c-50.4 24.6-80 67.4-66.5 97.7 14 31.6 69.4 37.7 123.7 13.5 20-8.9 37.1-20.6 50-33.5 26.7-30.3 37.2-66.5 23.9-96.4-21.1-47.2-93.6-60.9-161.9-30.4-68.4 30.4-106.8 93.4-85.8 140.7 21.1 47.2 100.5 76.4 168.9 45.9 1.5-0.6 3.3 0.2 4 1.7 0.7 1.6 0.1 3.4-1.5 4.1-80.3 35.8-170.2 9-192.9-42.1-22.8-51.1 23.9-121.5 104.2-157.3 80.3-35.7 163.8-23.3 186.6 27.8 19.2 43.3-11.2 100.3-69.7 138.6-6.6 4.1-13.8 7.6-21.3 10.9-59.4 26.4-122 15.3-139.9-24.9-17.2-38.6 12.6-91.7 67.8-119.2 0 0-22.8-9-22.7-9-0.3-0.2-0.5-0.5-0.7-0.8-0.4-1-0.1-2.1 0.7-2.4 0.2-0.1 0.5-0.2 0.8-0.1zm69 114.4h-9.9l-3.8-9.2h-15.2l-3.8 9.2h-16.2c-4.8 0-3.3 0-4.5 0-6-0.3-9.7-2.3-11.9-6.4-1.3-2.3-1.8-5.4-1.8-11.1v-22.3h8.5v22.3c0 4.4 0.1 4.6 0.3 5.7 0.4 2.3 2.1 3.9 4.8 4.4 1.4 0.2 2.6 0.3 5.5 0.3h8.2l13.6-32.7h9.7zm-15.6-16.4l-5.7-13.9-5.7 13.9zm37.2-16.3h-11.7v32.7h-8.5v-32.7h-12.7v-7.1h41.4v23.8c0 3.9 0.6 5.8 2.2 7.3 1.5 1.4 4.2 2.3 6.7 2.3 4 0 7.1-1.4 8.1-3.8 0.5-1.1 0.8-2.9 0.8-5.8v-23.8h8.4v23.4c0 6.4-1.3 10.3-4.3 12.8-3.1 2.6-7.3 3.9-13 3.9-6.4 0-10.9-1.4-13.8-4.4-2.7-2.7-3.6-5.6-3.6-11.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatu);
export default __webpack_public_path__ + "static/media/latu.e2e72faf900bfc584ad7e5f1e48a610e.svg";
export { ForwardRef as ReactComponent };